import { Component, Vue } from 'vue-property-decorator';
import { Language } from '@/enums/Language';

@Component
export class CookiesService extends Vue {
	set jv(id: Language) {
		this.setCookie("jv", id.toString(), 60 * 24 * 365 /* 1 year as in WMS2 */);
	}

	get jv(): Language {
		return +this.getCookie("jv") || null;
	}

	getFavoriteProducts(): string[] {	// changed to function from getter to avoid caching that ignores changes
		return (this.getCookie("favProducts") || "").split(".").filter(p => p != "");	// . is the delimiter because ,;: don't work in cookies
	}

	setFavoriteProducts(catalogNumbers: string[]) {
		this.setCookie("favProducts", catalogNumbers.join("."), 60 * 24 * 365 /* 1 year */);
		this.$userService.postSaveFavorites().catch(err => console.log("unauthorized to save favorite products to server"));
	}

	// based on https://stackoverflow.com/a/51313011
	private setCookie(name: string, value: string, minutes: number) {
		var expires = "";
		if (minutes) {
			var date = new Date();
			date.setTime(date.getTime() + (minutes * 60 * 1000));
			expires = "; expires=" + date.toUTCString();
		}
		document.cookie = name + "=" + (value || "") + expires + "; path=/";
	}

	// based on https://stackoverflow.com/a/51313011
	private getCookie(name: string): string {
		var nameEq = name + "=";
		var cookies = document.cookie.split(';');
		for (var i = 0; i < cookies.length; i++) {
			var cookie = cookies[i];
			while (cookie.charAt(0) == ' ') {
				cookie = cookie.substring(1, cookie.length);
			}
			if (cookie.indexOf(nameEq) == 0) {
				return cookie.substring(nameEq.length, cookie.length);
			}
		}
		return null;
	}
}
